import FooterSvg  from "./footer.svg";
import Footercurve from '../../assets/background/footer-curve.svg'
import './index.css'
import SocialMedia from "../socialmedia";
import { BorderButton } from "../button";
import FillButton from "../button/FillButton";
const Footer = () => {
  return (
    <footer
      id="Contact"
      style={{
        marginTop: "50vh",

        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "90vh",
          backgroundImage: `url(${FooterSvg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <img src={Footercurve} style={{ width: "100%" }} alt="" />
        <h1 class="font-medium footer-text md:footer-text text-center">Connect with me on social media.</h1>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <SocialMedia />
        </div>
        <div style={{ display: "flex", marginTop: "2rem", gap: "1rem", justifyContent: "center", alignItems: "center" }}>
          <BorderButton name="Resume" />
          <FillButton name="Let's talk"/>
        </div>
        <div className="text-1xl" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2rem", fontWeight: "600", textAlign: "center", padding: "0 2rem 0 2rem" }}>
          Designed and developed with ❤️ by Pratik.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
